module.exports = __webpack_public_path__ + "static/img/07.78d7b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution/low-code/07.jpg
// module id = 2xh8
// module chunks = 1